import { CuredApiPaths } from '../../models/enums';
import { UseMutationOptions } from '@tanstack/react-query';
import { PathWithID } from '../../models/types';
import { ApiMethods } from '../../models/enums';
import useMutation from '../useMutation';
import MutationKeys from './keys';

const useDeleteContentFolder = (folderId: string, mutateOptions?: UseMutationOptions<unknown, Error>) =>
    useMutation(
        MutationKeys.DELETE_CONTENT_FOLDER,
        new PathWithID(CuredApiPaths.CONTENT_FOLDERS, folderId),
        mutateOptions,
        ApiMethods.DELETE
    );

export default useDeleteContentFolder;
